module.exports = __webpack_public_path__ + "static/media/p9.2a9d4ed2.webp";